import React, {Component} from "react";
import MajorSelect from "./MajorSelect";
import MinorSelect from "./MinorSelect";
import YearSelect from "./EnteringYear";
import CollegeSelect from "./CollegeSelect";
import requests from "../../constants/requests";
import {toast} from "react-toastify";
import Skeleton from "@material-ui/lab/Skeleton";

const getSkeleton = function() {
    const NUM = 7;
    const result = [];
    for(let i = 0; i < NUM; i++) {
        result.push(
            <div style={{margin: 10}}>
                <Skeleton variant={"rect"} width={280} height={44} />
            </div>
        )
    }
    return <div style={{width: '100%', display: 'flex', flexDirection: 'column', alignItem: 'center'}}>{result}</div>;
}

class InfoPopUp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            isLoading: true
        };

        this.majors = [];
        this.minors = [];
        this.enteringYears = [];
        this.colleges = [];
        this.plan = this.props.originalPlan;

        this.getOptions = this.getOptions.bind(this);

        this.getOptions();

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.setMajor = this.setMajor.bind(this);
        this.setMinor = this.setMinor.bind(this);
        this.setEnteringYear = this.setEnteringYear.bind(this);
        this.setCollege = this.setCollege.bind(this);
    }

    getOptions() {
        fetch(requests.AVAILABLE_SETTING(), {
            method: 'POST',
            headers: requests.HEADER(),
            body: JSON.stringify({
                "token": this.props.token
            })
        }).then((res) => {
            res.json().then((response) => {
                if(!response.isTokenValid) {
                    this.props.onLogout();
                }
                if(response.success) {
                    this.majors = response.majors;
                    this.minors = response.minors;
                    this.enteringYears = response.enteringYears;
                    this.colleges = response.colleges;
                    this.setState({ isLoading: false })
                } else {
                    toast("Getting available plan setting options failed, trying in 3 seconds.");
                    console.log(response.errMsg);
                    setTimeout(() => this.getOptions(), 3000);
                }
            }).catch((err) => {
                toast("Getting available plan setting options failed, trying in 3 seconds.");
                console.log(err);
                setTimeout(() => this.getOptions(), 3000);
            })
        }).catch((err) => {
            toast("Getting available plan setting options failed, trying in 3 seconds.");
            console.log(err);
            setTimeout(() => this.getOptions(), 3000);
        });
    }

    setMajor(index, major) {
        const plan = this.plan;
        plan.majors[index] = major;
        this.props.setPlan(plan);
        this.plan = plan;
    }

    setMinor(index, minor) {
        const plan = this.plan;
        plan.minors[index] = minor;
        this.props.setPlan(plan);
        this.plan = plan;
    }

    setEnteringYear(enteringYear) {
        const plan = this.plan;
        plan.enteringYear = enteringYear;
        this.props.setPlan(plan);
        this.plan = plan;
    }

    setCollege(college) {
        const plan = this.plan;
        plan.college = college;
        this.props.setPlan(plan);
        this.plan = plan;
    }

    openModal() {
        this.setState({open: true});
    }

    closeModal() {
        this.setState({open: false});
    }

    render() {
        return (
            <div style={{ marginTop: 20, width: '90%' }}>
                <div className="modal" style={{width: '100%', textAlign: 'center'}}>
                    {
                        this.state.isLoading
                            ? getSkeleton()
                            : <div style={{width:'100%'}}>
                        <MajorSelect setMajor={(major) => {
                            this.setMajor(0, major)
                        }} labelName={'First Major'} originalMajor={this.props.originalPlan.majors[0]}
                                      majors={this.majors}
                        />
                            <MajorSelect setMajor={(major) => {
                            this.setMajor(1, major)
                        }} labelName={'Second Major'} originalMajor={this.props.originalPlan.majors[1]}
                            majors={this.majors}
                            />
                            <MinorSelect setMinor={(minor) => {
                            this.setMinor(0, minor)
                        }} labelName={'First Minor'} originalMinor={this.props.originalPlan.minors[0]}
                            minors={this.minors}
                            />
                            <MinorSelect setMinor={(minor) => {
                            this.setMinor(1, minor)
                        }} labelName={'Second Minor'} originalMinor={this.props.originalPlan.minors[1]}
                                         minors={this.minors}
                            />
                            <MinorSelect setMinor={(minor) => {
                            this.setMinor(2, minor)
                        }} labelName={'Third Minor'} originalMinor={this.props.originalPlan.minors[2]}
                                         minors={this.minors}
                            />
                            <YearSelect setEnteringYear={this.setEnteringYear} labelName={'Entering Year'}
                            originalEnteringYear={this.props.originalPlan.enteringYear}
                            enteringYears={this.enteringYears}
                            />
                            <CollegeSelect setCollege={this.setCollege} labelName={'College'}
                            originalCollege={this.props.originalPlan.college} colleges={this.colleges}
                            />
                            </div>
                    }
                </div>
            </div>
        );
    }
}

export default InfoPopUp;